import { render, staticRenderFns } from "./TermsnCondition.vue?vue&type=template&id=b15a498e&scoped=true"
import script from "./TermsnCondition.vue?vue&type=script&lang=js"
export * from "./TermsnCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsnCondition.vue?vue&type=style&index=0&id=b15a498e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15a498e",
  null
  
)

export default component.exports